<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">SDK初始化</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			SDK初始化是使用SDK的第一步，
			在该过程中完成向系统申请内存、加载人脸识别模型、授权等操作，首次授权需访问外网。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//SDK初始化
+ (BOOL)skFaceInitSDKWithApiKey:(NSString *)apiKey
                   apiSecret:(NSString *)apiSecret
                sdkInitCallback:(EventInitCallBack)sdkInitCallback;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）apiKey：当前APP所申请的SKEye的API_KEY</p>
        <p class="doc_main_p">（2）apiSecret：当前APP所申请的SKEye的API_SECRET</p>
        <p class="doc_main_p">（3）sdkInitCallback (int Code, NSString * msg)：SDK授权结果回调函数，Code:初始化状态码，msg：初始化状态信息</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">BOOL类型,SDK初始化结果，成功为true，失败为false，初始化成功后可调用检测相关接口。
		</p>
		<h3 class="doc_main_h3">授权结果错误码信息</h3>
		<authority-error-code></authority-error-code>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">//SDK初始化示例代码
[SKFaceManagerInterface  skFaceInitSDKWithApiKey:@" " apiSecret:@" " 
  sdkInitCallback:^(int code, NSString *msg) 
  {
       if (code == 0) 
       {
         NSLog(@"%d 初始化成功 %@", code, msg);
       }
  }
];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','基础接口','SDK初始化'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/basics/SDKInitial.vue